// extracted by mini-css-extract-plugin
export default {"select-width":"HourMinuteSelector_select-width__yg8jF","booking-form-input":"HourMinuteSelector_booking-form-input__S4LGy"};